import { Component } from '@angular/core';

@Component({
  selector: 'app-internal-screen-layout',
  standalone: false,
  template: `
    <div class="internal min-h-full">
      <div class="md:container md:mx-auto md:px-4">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: [
  ]
})
export class InternalScreenLayoutComponent {

}
